const ManageReport = () => {
  return <div>Page 03</div>;
};

export default ManageReport;
